import { render, staticRenderFns } from "./StudyProductSubscriptionItem.vue?vue&type=template&id=239890e9&scoped=true&"
import script from "./StudyProductSubscriptionItem.vue?vue&type=script&lang=js&"
export * from "./StudyProductSubscriptionItem.vue?vue&type=script&lang=js&"
import style0 from "./StudyProductSubscriptionItem.vue?vue&type=style&index=0&id=239890e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239890e9",
  null
  
)

export default component.exports